import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-click'))),
    class: "text-white bg-indigo-600 px-4 py-3 rounded-lg font-semibold text-xs md:text-sm cursor-pointer"
  }, _toDisplayString(_ctx.btnTxt), 1))
}